/* @ngInject */

export default () => {
  return function (input, type) {
    var out = [];
    if (!type || type === '') {
      out = input;
    } else {
      out = _.filter(input, function (label) {
        if (type !== null) {
          return label.type.name === type;
        }
      });
    }
    return out;
  };
};
